import { create } from 'zustand';
import { getRegisteredUsers } from '../../../api/api';

export const useRegisteredUsersStore = create((set) => ({
  data: [],
  isLoading: false,
  error: null,

  fetchRegisteredUsers: async () => {
    set({ isLoading: true, error: null });

    getRegisteredUsers(
      (data) => {
        set({ data, isLoading: false });
      },
      (err) => {
        set({ error: err, isLoading: false });
      }
    );
  },
}));
